export default __webpack_public_path__ + "static/media/default.1b29ac08.png";